export default __webpack_public_path__ + "static/media/pie-chart.8a8301ec.svg";